module.exports = __webpack_public_path__ + "static/assembly2-2-ab19a002211f1b73543796a338735782.jpg";